module.exports = __webpack_public_path__ + "static/img/PL.cf2ea70b.svg";